module.exports = __webpack_public_path__ + "static/recent-orders-1318cbf012886610e7242be71bf22e60.png";